/** @format */

import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID, makeStateKey, TransferState } from '@angular/core';

import { Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';

import { CustomHttpHeaders, MediaType } from '@shared/data-access/enums';

import { Environment } from '@shared/data-access/interfaces';

@Injectable({
	providedIn: 'root'
})
export class FileDao {
	readonly FILE_STATE_KEY_PREFIX = 'file-';

	constructor(
		private environment: Environment,
		private http: HttpClient,
		@Inject(PLATFORM_ID) private platformId,
		private state: TransferState
	) {}

	/**
	 * @description
	 * Gets a data file by name and type
	 */
	public getDataFileByType$(fileName: string, fileType: string, retries = 0): Observable<any> {
		// Get unique key
		const STATE_KEY = makeStateKey(`${this.FILE_STATE_KEY_PREFIX}${fileName}`);

		// Attempt to get the state by key
		const stateData: any = this.state.get(STATE_KEY, null);

		// Check to see if state exists
		if (stateData) {
			// Return the existing state
			return new Observable((observer) => {
				observer.next(stateData);
				observer.complete();
			});
		}

		// Standard HTTP Headers
		let httpHeaders = new HttpHeaders();

		// Check file type to specify `Accept` header value
		/* istanbul ignore else */
		if (typeof fileType === 'string' && fileType.toLowerCase().trim() === 'json') {
			httpHeaders = httpHeaders.set('Accept', MediaType.APPLICATION_JSON);
		} else if (typeof fileType === 'string' && fileType.toLowerCase().trim() === 'csv') {
			httpHeaders = httpHeaders.set('Accept', MediaType.TEXT_CSV);
		}

		// Custom HTTP Headers
		httpHeaders = httpHeaders.set(CustomHttpHeaders.X_PROXY_REQUEST, 'true');

		// Check platform
		if (!isPlatformBrowser(this.platformId)) {
			// Set a timeout on the server to prevent the response from taking too long
			httpHeaders = httpHeaders.set(
				CustomHttpHeaders.X_TIMEOUT,
				`${this.environment.dataFiles[fileType].proxy.timeout}`
			);
		}

		// HTTP Options
		const httpOptions = {
			headers: httpHeaders
		};

		// Make the HTTP Request
		return this.http
			.get(`${this.environment.dataFiles[fileType].proxy.path}${fileName}`, httpOptions)
			.pipe(
				map((response: any) => {
					// Set the state
					this.state.set(STATE_KEY, response);

					return response;
				}),
				retry(retries)
			);
	}
}
